"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  label: 'HTML Attributes',
  type: 'datamap',
  input: true,
  key: 'attributes',
  keyLabel: 'Attribute Name',
  valueComponent: {
    type: 'textfield',
    key: 'value',
    label: 'Attribute Value',
    input: true
  },
  tooltip: 'Provide a map of HTML attributes for component\'s input element (attributes provided by other component settings or other attributes generated by form.io take precedence over attributes in this grid)',
  addAnother: 'Add Attribute'
}];
exports.default = _default;